import { Component, OnInit } from '@angular/core';
import { ImageLoaderComponent } from 'src/app/shared/components';
import { CurrentFacilityService } from 'src/app/shared/services';

@Component({
    selector: 'app-empty-card-list',
    imports: [ImageLoaderComponent],
    templateUrl: './empty-card-list.component.html',
    styleUrls: ['./empty-card-list.component.scss'],
    standalone: true,
})
export class EmptyCardListComponent implements OnInit {
    public facilityName: string;

    constructor(private currentFacilityService: CurrentFacilityService) {}

    ngOnInit(): void {
        this.facilityName = this.currentFacilityService.getFacilitySource();
    }
}
